import React, { useEffect, useRef } from 'react';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

const ingredients = [
  {
    name: 'Piemonte Hazelnoten',
    description: 'Geoogst in de heuvels van Noord-Italië',
    image: 'https://customer-assets.emergentagent.com/job_dutch-spread-shop/artifacts/pqeckd7q_image.png',
  },
  {
    name: 'Madagascar Vanille',
    description: 'De fijnste vanillestokjes ter wereld',
    image: 'https://customer-assets.emergentagent.com/job_dutch-spread-shop/artifacts/iyt1ob9a_image.png',
  },
  {
    name: 'Rainforest Alliance Cacao',
    description: 'Duurzaam geteelde premium cacao',
    image: 'https://customer-assets.emergentagent.com/job_dutch-spread-shop/artifacts/ya2yaajd_image.png',
  },
];

const IngredientsSection = () => {
  const sectionRef = useRef(null);
  const cardsRef = useRef([]);

  useEffect(() => {
    const ctx = gsap.context(() => {
      cardsRef.current.forEach((card, index) => {
        gsap.from(card, {
          scrollTrigger: {
            trigger: card,
            start: 'top 85%',
            end: 'top 60%',
            toggleActions: 'play none none reverse',
          },
          y: 60,
          opacity: 0,
          duration: 0.8,
          delay: index * 0.15,
          ease: 'power3.out',
        });
      });
    }, sectionRef);

    return () => ctx.revert();
  }, []);

  return (
    <section
      ref={sectionRef}
      className="py-24 lg:py-32 px-8"
      style={{ backgroundColor: 'var(--penotti-vanilla)' }}
    >
      <div className="max-w-[1400px] mx-auto">
        <div className="text-center mb-16">
          <div className="w-24 h-px bg-[var(--atelier-gold)] mx-auto mb-8" />
          <h2 className="text-5xl md:text-6xl font-light mb-6" style={{ color: 'var(--atelier-black)' }}>
            Onze Ingrediënten
          </h2>
          <p className="text-xl" style={{ color: 'var(--atelier-grey)' }}>
            Alleen het beste, van de beste plekken ter wereld
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
          {ingredients.map((ingredient, index) => (
            <div
              key={index}
              ref={(el) => (cardsRef.current[index] = el)}
              className="group cursor-pointer"
            >
              <div className="relative aspect-square overflow-hidden mb-6 bg-white rounded-lg">
                <img
                  src={ingredient.image}
                  alt={ingredient.name}
                  className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
              </div>
              <h3 className="text-2xl font-light mb-3" style={{ color: 'var(--atelier-black)' }}>
                {ingredient.name}
              </h3>
              <p className="text-sm" style={{ color: 'var(--atelier-grey)' }}>
                {ingredient.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default IngredientsSection;